import { render, staticRenderFns } from "./theoryEntrance.vue?vue&type=template&id=3b3748dd&scoped=true"
import script from "./theoryEntrance.vue?vue&type=script&lang=js"
export * from "./theoryEntrance.vue?vue&type=script&lang=js"
import style0 from "./theoryEntrance.vue?vue&type=style&index=0&id=3b3748dd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3748dd",
  null
  
)

export default component.exports